import { render, staticRenderFns } from "./SwiperFourSlides.vue?vue&type=template&id=569c6328&scoped=true"
import script from "./SwiperFourSlides.vue?vue&type=script&lang=js"
export * from "./SwiperFourSlides.vue?vue&type=script&lang=js"
import style0 from "./SwiperFourSlides.vue?vue&type=style&index=0&id=569c6328&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569c6328",
  null
  
)

export default component.exports